var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-container"},[(_vm.fetched)?_c('div',{staticClass:"video"},[_c('vimeo-player',{ref:"player",attrs:{"video-id":_vm.video_id}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }